/* eslint-disable import/prefer-default-export */
import {FIELD_SETTING_TYPES} from '../../../../../constants';

export interface SignatureFieldDefinition {
    id: number;
    signing_type?: string;
    isOptional: boolean;
}

export interface RecipientFieldDefinition {
    id: number;
    settingType: string;
}

export interface FormFieldDefinition {
    id: number;
    settingType: string;
}

export function getDefaultSignatureType(isMobileActive: boolean, defaultSignatureType = ''): string {
    switch (defaultSignatureType.toUpperCase()) {
        case 'SIGN':
            return 'signature';
        case 'CAPTURE':
            return 'capture';
        case 'MOBILE':
            return isMobileActive ? 'mobile_capture' : 'signature';
        default:
            return 'signature';
    }
}

export const SIGNATURE_FIELDS: SignatureFieldDefinition[] = [
    {id: 1, signing_type: 'capture', isOptional: false},
    {id: 2, signing_type: 'signature', isOptional: false},
    {id: 3, signing_type: 'initials', isOptional: false},
    {id: 6, signing_type: 'paraph', isOptional: false},
    {id: 4, signing_type: 'mobile_capture', isOptional: false},
    {id: 5, isOptional: true}
];

export const RECIPIENT_FIELDS: RecipientFieldDefinition[] = [
    {id: 6, settingType: FIELD_SETTING_TYPES.SIGNER_NAME},
    {id: 7, settingType: FIELD_SETTING_TYPES.SIGNING_DATE},
    {id: 8, settingType: FIELD_SETTING_TYPES.SIGNER_TITLE},
    {id: 9, settingType: FIELD_SETTING_TYPES.SIGNER_COMPANY}
];

export const FORM_FIELDS: FormFieldDefinition[] = [
    {id: 15, settingType: FIELD_SETTING_TYPES.DATEPICKER},
    {id: 10, settingType: FIELD_SETTING_TYPES.SINGLE_LINE},
    {id: 11, settingType: FIELD_SETTING_TYPES.MULTI_LINE},
    {id: 12, settingType: FIELD_SETTING_TYPES.CHECKBOX},
    {id: 13, settingType: FIELD_SETTING_TYPES.DROPDOWN},
    {id: 14, settingType: FIELD_SETTING_TYPES.RADIO},
    {id: 16, settingType: FIELD_SETTING_TYPES.LABEL}
];
